import { useSelector } from 'react-redux'
/* import { useState } from 'react' */
import { useNavigate } from 'react-router-dom'

import { useMediaQuery } from '@mui/material'

import './header.css'
import logoPretzu from './svg/logoPretzu.svg'
import imgRejilla from './svg/imgRejilla.svg'

import { InfoUser } from '../infoUserAuto/InfoUser'
import { BellIcon } from 'lucide-react'


export const Header = ({ stateMenu, setOpenMenu }) => {
    /* const dispatch = useDispatch(); */

    const isMobile = useMediaQuery('(max-width:768px)');
    const navigate = useNavigate()

    const { nombre_comercial } = useSelector(state => state.general.info)
   /*  const { name } = useSelector(state => state.auth) */
    /* const [cantidadNotificaciones, setCantidadNotificaciones] = useState(0) */
    const cantidadNotificaciones = 0

    const gestionarCuenta = () => {
        navigate(`/notificaciones`);
    }

    return (
        <div className='row header-box'>

            <div className={`${isMobile ? 'col-9' : 'col-2'} d-flex align-items-center`}>
                <img onClick={setOpenMenu} role="button" src={imgRejilla} alt='abrir menú' className={`p-2 header-rejilla ${stateMenu === 'medium_open' && 'header-rejilla-closed'}`} />
                <img className='header-logo' src={logoPretzu} alt='logo pretzu' />
            </div>

            {!isMobile &&
                <div className='col-7 d-flex align-items-center justify-content-start'>
                    <span style={{ textTransform: 'capitalize' }}>{nombre_comercial}</span>
                </div>
            }

            <div className='col-3 d-flex align-items-center justify-content-end header-user'>
                {/* <img src={imgSearch} alt='img buscar' /> */}
                {/* <img src={imgVoz} alt='img asistente' /> */}

                <button
                    onClick={gestionarCuenta}
                    className='me-3 flex items-end justify-end relative'
                >
                    <BellIcon className='w-5 h-5' />
                    {cantidadNotificaciones > 0 &&
                        <span className='bg-red-600 text-white rounded-full w-4 h-4 flex items-center justify-center text-[9px] absolute top-[-6px] right-[-5px]'>{cantidadNotificaciones}
                        </span>
                    }
                </button>
                <InfoUser />
            </div>

        </div >
    );
}
